import Model from './Model'

export default class DemoConfigModel extends Model {
  public id: number|undefined

  resource () : string {
    return 'demoConfigs'
  }
}
